
import { CountryInformation } from '@/store/dueDiligence/types';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { RiskCategory as RiskCategories } from '@/store/dueDiligence/constants';
@Component
export default class CPDueDiligenceDocumentRequirements extends Vue {
    @Prop({ required: true })
    public readonly countryInfo!: CountryInformation | null;
    
    @Prop({ required: true })
    public readonly title!: string;

    public riskCategories = RiskCategories;
}
